import { useState } from "react";
import { errMsg } from "@/lib/errors";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try { const u = await login(email, password); nav(u.business_id ? "/app" : "/onboarding"); }
    catch (err) { const msg = errMsg(err, "Login failed"); setError(msg); }
    finally { setLoading(false); }
  };
  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center gap-2 justify-center mb-8">
          <div className="w-9 h-9 rounded-xl bg-slate-950 text-white flex items-center justify-center font-bold">A</div>
          <span className="font-heading font-extrabold text-xl tracking-tight">ASFA</span>
        </Link>
        <div className="bg-white border border-slate-200 rounded-2xl p-8 shadow-sm">
          <h1 className="text-2xl font-bold tracking-tight text-slate-950">Welcome back</h1>
          <p className="text-sm text-slate-600 mt-1">Sign in to your ASFA account.</p>
          <form onSubmit={onSubmit} className="mt-6 space-y-4">
            <div>
              <Label htmlFor="email">Email</Label>
              <Input data-testid="login-email" id="email" type="email" required value={email}
                onChange={(e) => setEmail(e.target.value)} className="mt-1.5" />
            </div>
            <div>
              <Label htmlFor="password">Password</Label>
              <Input data-testid="login-password" id="password" type="password" required value={password}
                onChange={(e) => setPassword(e.target.value)} className="mt-1.5" />
            </div>
            <Button data-testid="login-submit" type="submit" disabled={loading}
              className="w-full rounded-xl bg-blue-600 hover:bg-blue-700 h-11">
              {loading ? "Signing in..." : "Sign in"}
            </Button>
            {error && <div data-testid="login-error" role="alert" className="text-sm text-red-600 bg-red-50 border border-red-100 rounded-xl px-3 py-2">{error}</div>}
          </form>
          <div className="mt-6 text-sm text-center text-slate-600">
            Don't have an account? <Link to="/signup" className="text-blue-600 font-medium">Get started</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
